import { c as _c } from "react/compiler-runtime";
import Link from '@/components/elements/Link';
import BookButton from '@/components/modules/entityBookButtons/BookButton';
import OfferButton from '@/components/modules/entityBookButtons/OfferButton';
import InlineRating from '@/components/modules/rating/InlineRating';
import { ESTABLISHMENT_CITY, ESTABLISHMENT_NAME, WITH_REVIEWS } from '@/constants/config';
import { EXPERIENCE_TYPES } from '@/constants/experience';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { BBookableReceptionTypeEnum } from '@/types/backend';
import { ReceptionTypeTag } from '@winelidays/wld-tsx-2/elements';
import { TitleBanner } from '@winelidays/wld-tsx-2/modules';
const ExperienceTitleBanner = (t0) => {
    const $ = _c(24);
    const { experience } = t0;
    const translate = useTranslate();
    const { name, informations, typeActivity, rating } = experience;
    let t1;
    if ($[0] !== informations.receptionType || $[1] !== translate) {
        t1 = informations.receptionType === BBookableReceptionTypeEnum.Private ?
            <ReceptionTypeTag receptionType={informations.receptionType} className="" translate={translate} linkComponent={Link}/> : null;
        $[0] = informations.receptionType;
        $[1] = translate;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    const privateTag = t1;
    let t2;
    if ($[3] !== name) {
        t2 = <h1 className="experience-title text-title mb-1 mr-2 inline align-middle">{name}</h1>;
        $[3] = name;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    let t3;
    if ($[5] !== privateTag || $[6] !== t2) {
        t3 = <div className="mb-4 text-center md:mb-2 md:text-left">{t2}
      {privateTag}
    </div>;
        $[5] = privateTag;
        $[6] = t2;
        $[7] = t3;
    }
    else {
        t3 = $[7];
    }
    let t4;
    if ($[8] !== typeActivity.name) {
        t4 = <p className="experience-type flex flex-row uppercase font-semibold mb-4 md:mb-2">
      {typeActivity.name}
    </p>;
        $[8] = typeActivity.name;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    let t5;
    if ($[10] !== rating) {
        t5 = WITH_REVIEWS ?
            <div className="reviews flex flex-row items-center mb-4 md:mb-2">
      <InlineRating {...rating} loading={false}/>


    </div> : null;
        $[10] = rating;
        $[11] = t5;
    }
    else {
        t5 = $[11];
    }
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <p className="text-sm font-semibold flex flex-col items-center md:block">
      <span className="establishment-name mb-2 text-center md:mr-2 md:mb-0">
        {ESTABLISHMENT_NAME}
      </span>
      <span className="establishment-location text-gray-400 text-center md:text-left">
        {ESTABLISHMENT_CITY}
      </span>
    </p>;
        $[12] = t6;
    }
    else {
        t6 = $[12];
    }
    let t7;
    if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t7 = <div className="flex flex-col items-center md:items-start">{t3}{t4}{t5}{t6}
    </div>;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t7;
    }
    else {
        t7 = $[16];
    }
    let t8;
    if ($[17] !== experience.canBeGifted || $[18] !== experience.identifier || $[19] !== experience.type) {
        t8 = EXPERIENCE_TYPES.includes(experience.type) ?
            <div className="book-buttons flex flex-col-reverse items-center justify-center w-full mt-6 max-w-screen-xxs md:mt-0 md:w-1/3 md:min-w-50 md:h-full md:items-end">
      <BookButton entityId={experience.identifier} className="w-full mt-2 last:mt-0 "/>
      {experience.canBeGifted ?
                    <OfferButton entityId={experience.identifier} className="w-full mt-2 last:mt-0 "/> : null}
    </div> : null;
        $[17] = experience.canBeGifted;
        $[18] = experience.identifier;
        $[19] = experience.type;
        $[20] = t8;
    }
    else {
        t8 = $[20];
    }
    let t9;
    if ($[21] !== t7 || $[22] !== t8) {
        t9 = <TitleBanner innerClassName="!flex-col !rounded-b !rounded-t-none md:!flex-row md:!items-center md:!justify-between lg:!rounded">{t7}{t8}
    </TitleBanner>;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    }
    else {
        t9 = $[23];
    }
    return t9;
};
export default ExperienceTitleBanner;
